module.exports = __webpack_public_path__ + "static/media/danger-alert.78c8e3fd.svg";